import RequestAbstract from "./RequestAbstract";

export default class RentgenDoze extends RequestAbstract {
    get link() {
        return this.links.rentgenDoze;
    }

    async getRentgenDose() {
        const res = await this.get(this.link);
        return res;
    }
}
